import { signal, WritableSignal } from '@angular/core';

import { OrderItem, OrderItemCreate } from 'frontend.client.api';
import { BehaviorSubject } from 'rxjs';
import { OrderState } from '../../models/order-state';
import { Partner } from '../../models/partner';

export class OrderServiceState {
  public orderState$ = new BehaviorSubject<OrderState>({
    order: undefined,
    isLoading: false,
    error: undefined,
  });
  public orderLockState$ = new BehaviorSubject<boolean>(false);
  public pollingState$ = new BehaviorSubject<boolean>(false);
  public creatingOrder: WritableSignal<boolean> = signal(false);
  public toastState = signal(false);

  public get orderState() {
    return this.orderState$;
  }

  public get pollingState() {
    return this.pollingState$;
  }

  protected orderItemToOrderItemCreate(
    orderItems?: OrderItem[],
  ): OrderItemCreate[] {
    return (
      orderItems?.map((item) => ({
        productType: item.productData.productType,
      })) ?? []
    );
  }
}
